import React from 'react'
import styled from 'styled-components'
import AboutusSection from './AboutusSection'
import ContactInfo from './ContactInfo'
import UsefulLinksSection from './UsefulLinksSection'
//importing images
import footer from '../../Images/footer/footer.jpg'

const FooterSection = () => {
    return (
        <StyledFooter img={footer}>
            <Container>
                <AboutusSection />
                <UsefulLinksSection />
                <ContactInfo />
            </Container>
            <Copyright>
                {/* <hr /> */}
                <p>Copyright © 2021  Web Solutions. All rights reserved.</p>
            </Copyright>
        </StyledFooter>
    )
}

export default FooterSection

const StyledFooter = styled.footer`
    background-image: linear-gradient(rgba(0, 2, 25, 0.9), rgba(0, 2, 25, 0.9)), url(${props => props.img});
    /* background-color: rgba(0, 2, 25, 0.8); */
    background-repeat: no-repeat;
    background-size: cover;
    /* z-index: 1; */
    background-position: -150%;
`


const Container = styled.div`
    /* background: #282828; */
    display: flex;
    padding: 0rem 5rem;
    @media screen and (max-width:900px){
        flex-direction: column;
        padding: 2rem;
    }
`;

const Copyright = styled.div`
    text-align: center;
    width: 100%;
    height: 100%;
    color: white;
    font-size: 1.1rem;
    p{
        color: #fff;
    }
    @media screen and (max-width:900px){
        font-size: 0.7rem
    }
`